/* ============================================================
   GOOD BANDS THEME · theme.js
   Cart drawer (AJAX), pack builder, product gallery, 3D wiring,
   sticky ATC, ticker loop, toasts.
============================================================ */
(function () {
  const $ = (s, r) => (r || document).querySelector(s);
  const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));
  const money = (cents) => {
    const v = (cents / 100).toFixed(2);
    return (window.GB && GB.moneyFormat ? GB.moneyFormat.replace(/\{\{\s*amount\s*\}\}/, v) : '$' + v).replace(/<[^>]+>/g, '');
  };
  window.gbToast = function (msg) {
    const t = $('#toast'); if (!t) return;
    t.textContent = msg; t.classList.add('show');
    clearTimeout(t._h); t._h = setTimeout(() => t.classList.remove('show'), 2300);
  };

  /* ---------- seamless ticker ---------- */
  $$('.ticker-track').forEach(tr => { tr.innerHTML += tr.innerHTML; });

  /* ---------- cart drawer ---------- */
  const drawer = {
    el: $('#drawerWrap'),
    open(force) {
      if (!this.el) return;
      const on = force !== undefined ? force : !this.el.classList.contains('open');
      this.el.classList.toggle('open', on);
    },
    async refresh() {
      const res = await fetch('/cart.js'); const cart = await res.json();
      $$('[data-cart-count]').forEach(n => n.textContent = cart.item_count);
      const lines = $('#cartLines'); if (!lines) return cart;
      lines.innerHTML = cart.items.length ? cart.items.map((i, idx) => {
        const props = Object.entries(i.properties || {}).map(([k, v]) => `<span class="props">${k}: ${v}</span>`).join('');
        return `<div class="line"><div><b>${i.product_title}</b>${i.variant_title && i.variant_title !== 'Default Title' ? `<small>${i.variant_title}</small>` : ''}${props}<small>${money(i.final_line_price)}</small></div>
        <div class="qty"><button data-line="${idx + 1}" data-d="-1">−</button>${i.quantity}<button data-line="${idx + 1}" data-d="1">+</button></div></div>`;
      }).join('') : `<div class="empty">Your cart is empty.<br>Packs ship free over ${money(GB.freeShip)}.</div>`;
      $('#cartTotal') && ($('#cartTotal').textContent = money(cart.total_price));
      const m = $('#shipMsg');
      if (m) {
        const t = cart.total_price, F = GB.freeShip;
        m.innerHTML = t >= F
          ? `<span class="done">✓ Free US shipping unlocked</span><div class="bar"><div class="fill" style="width:100%"></div></div>`
          : `You're ${money(F - t)} from free shipping<div class="bar"><div class="fill" style="width:${Math.min(100, t / F * 100)}%"></div></div>`;
      }
      return cart;
    },
    async change(line, delta) {
      const res = await fetch('/cart.js'); const cart = await res.json();
      const item = cart.items[line - 1]; if (!item) return;
      await fetch(GB.cartChangeUrl + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line, quantity: item.quantity + delta })
      });
      this.refresh();
    }
  };
  window.gbDrawer = drawer;
  document.addEventListener('click', e => {
    if (e.target.closest('[data-cart-toggle]')) { e.preventDefault(); drawer.open(); }
    if (e.target.closest('.scrim') || e.target.closest('[data-cart-close]')) drawer.open(false);
    const q = e.target.closest('#cartLines .qty button');
    if (q) drawer.change(+q.dataset.line, +q.dataset.d);
  });
  drawer.refresh();

  async function addItems(items) {
    const res = await fetch(GB.cartAddUrl + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items })
    });
    if (!res.ok) { gbToast('Could not add to cart'); return false; }
    await drawer.refresh(); gbToast('Added. Good choice'); drawer.open(true);
    return true;
  }
  window.gbAddItems = addItems;

  /* quick add buttons (product cards, cross-sell) */
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-quick-add]');
    if (b) { e.preventDefault(); addItems([{ id: +b.dataset.quickAdd, quantity: 1 }]); }
  });

  /* ---------- signup popup ---------- */
  const pop = $('#popWrap');
  if (pop) {
    document.addEventListener('click', e => { if (e.target.closest('[data-pop-close]')) { pop.classList.remove('show'); try { localStorage.setItem('gb_pop_seen', '1'); } catch (er) {} } });
    let seen = false; try { seen = !!localStorage.getItem('gb_pop_seen'); } catch (er) {}
    const pf = pop.querySelector('form');
    if (pf) pf.addEventListener('submit', () => { try { localStorage.setItem('gb_pop_seen', '1'); } catch (er) {} });
    if (new URLSearchParams(location.search).get('customer_posted') === 'true') { pop.classList.add('show'); const c = $('#popCode'); if (c) c.style.display = 'block'; if (pf) pf.style.display = 'none'; }
    else if (!seen) setTimeout(() => pop.classList.add('show'), (+pop.dataset.delay || 5) * 1000);
  }

  /* ---------- product page ---------- */
  const root = $('#ProductRoot');
  if (!root) return;
  const product = JSON.parse($('#ProductJson').textContent);
  const colorIdx = Math.max(0, (+root.dataset.colorIndex || 1) - 1);
  const minBands = +root.dataset.minBands || 3;

  // color map "Name:#hex, Name:#hex"
  const HEX = {};
  (root.dataset.colorMap || '').split(/[\n,]/).forEach(pair => {
    const m = pair.split(':'); if (m.length === 2) HEX[m[0].trim()] = m[1].trim();
  });
  const hexFor = name => HEX[name] || '#241F21';

  // variants by color value
  const byColor = {};
  product.variants.forEach(v => { const c = v.options[colorIdx]; if (c && !byColor[c]) byColor[c] = v; });
  const colorNames = product.options[colorIdx]
    ? product.variants.map(v => v.options[colorIdx]).filter((v, i, a) => a.indexOf(v) === i)
    : [];

  // 3D viewer
  let viewer = null;
  const v3d = $('#viewer3d');
  if (v3d && window.GBBand3D) {
    let amap = {};
    try { amap = JSON.parse(root.dataset.albedoMap || '{}'); } catch (e) {}
    viewer = GBBand3D(v3d, {
      color: hexFor(colorNames[0]), colorName: colorNames[0],
      glbUrl: root.dataset.glbUrl || undefined, albedoMap: amap,
      onFail: () => {                      // model failed: fall back to the photo gallery
        const s = v3d.closest('.slide'); if (s) s.remove();
        const c = document.querySelector('.thumb--cube'); if (c) c.remove();
        const f = document.querySelector('#thumbs .thumb'); if (f) f.click();
      }
    });
  }

  // gallery
  const thumbs = $('#thumbs');
  thumbs && thumbs.addEventListener('click', e => {
    const b = e.target.closest('.thumb'); if (!b) return;
    $$('.thumb', thumbs).forEach(t => t.classList.toggle('on', t === b));
    $$('.stage .slide').forEach(s => s.classList.toggle('on', s.dataset.slide === b.dataset.go));
  });
  const show3D = () => { const c = $('.thumb--cube'); c && c.click(); };

  const priceEl = $('#pdPrice'), perEl = $('#pdPer'), atc = $('#atcBtn');
  const stickyPrice = $('#stickyPrice'), stickyMeta = $('#stickyMeta');

  if (root.dataset.enableBuilder === 'true') {
    /* ----- PACK BUILDER: duplicates welcome, unlimited, min enforced ----- */
    const perBand = (byColor[colorNames[0]] || product.variants[0]).price; // cents
    const entryPrice = +root.dataset.entryPrice || 0;
    const entryNote  = root.dataset.entryNote || '';
    const leadEntry  = root.dataset.leadPrice === 'entry' && entryPrice > 0;
    let pack = [];
    const chipsEl = $('#chips');
    colorNames.forEach(name => {
      const v = byColor[name];
      const b = document.createElement('button');
      b.className = 'chip'; b.style.background = hexFor(name);
      b.title = name + (v && v.available === false ? ' · sold out' : ' · tap to add');
      b.dataset.name = name; b.innerHTML = '<span class="ct"></span>';
      if (v && v.available === false) { b.style.opacity = .3; b.style.cursor = 'not-allowed'; }
      else b.onclick = () => {
        pack.push(name);
        $('#lastColor') && ($('#lastColor').textContent = name);
        viewer && viewer.setColor(hexFor(name), name);
        show3D(); render();
      };
      chipsEl.appendChild(b);
    });
    const label = () => {
      const c = {}; pack.forEach(p => c[p] = (c[p] || 0) + 1);
      return Object.entries(c).map(([n, k]) => k > 1 ? `${n} ×${k}` : n).join(' + ');
    };
    function render() {
      $$('.chip', chipsEl).forEach(ch => {
        const n = pack.filter(p => p === ch.dataset.name).length;
        ch.classList.toggle('on', n > 0);
        ch.querySelector('.ct').textContent = '×' + n;
      });
      const tray = $('#tray'); tray.innerHTML = '';
      const hint = $('#trayHint'); if (hint) hint.classList.toggle('show', pack.length >= 1 && !window._gbRemoved);
      for (let i = 0; i < Math.max(minBands, pack.length); i++) {
        const s = document.createElement('button');
        s.className = 'slot' + (pack[i] ? ' filled' : '');
        if (pack[i]) { s.style.background = hexFor(pack[i]); s.title = 'Remove ' + pack[i]; s.onclick = () => { pack.splice(i, 1); window._gbRemoved = true; render(); }; }
        else s.textContent = i + 1;
        tray.appendChild(s);
      }
      const ok = pack.length >= minBands, total = pack.length * perBand;
      const msg = $('#packMsg');
      msg.innerHTML = pack.length === 0 ? 'Tap colors to fill your pack, doubles and triples welcome.'
        : !ok ? `In the pack: <b>${label()}</b>. Add ${minBands - pack.length} more to hit the ${minBands}-band minimum.`
        : `Your pack of ${pack.length}: <b>${label()}</b>. Add more anytime, same rate.`;
      atc.disabled = !ok;
      atc.textContent = ok ? `Add Pack to Cart · ${money(total)}` : `Pick ${minBands - pack.length} more`;
      if (leadEntry && pack.length === 0) {
        // Nothing picked yet: lead with the cheapest ready pack, not the custom total.
        priceEl.textContent = 'From ' + money(entryPrice);
        perEl.textContent = entryNote;
        stickyPrice && (stickyPrice.textContent = 'From ' + money(entryPrice));
        stickyMeta && (stickyMeta.textContent = entryNote);
      } else {
        priceEl.textContent = money(Math.max(pack.length, minBands) * perBand);
        perEl.textContent = money(perBand) + ' a band · pack of ' + Math.max(pack.length, minBands);
        stickyPrice && (stickyPrice.textContent = money(Math.max(pack.length, minBands) * perBand));
        stickyMeta && (stickyMeta.textContent = 'Pack of ' + Math.max(pack.length, minBands) + ' · ' + money(perBand) + '/band');
      }
    }
    async function submit() {
      if (pack.length < minBands) return;
      const counts = {}; pack.forEach(n => counts[n] = (counts[n] || 0) + 1);
      const items = Object.entries(counts).map(([name, qty]) => ({
        id: byColor[name].id, quantity: qty,
        properties: { 'Pack': label() }
      }));
      if (await addItems(items)) { pack = []; render(); }
    }
    atc.addEventListener('click', submit);
    $('#stickyAtc') && $('#stickyAtc').addEventListener('click', submit);
    render();
  } else {
    /* ----- STANDARD PICKER ----- */
    let sel = product.variants.find(v => v.available) || product.variants[0];
    const optWraps = $$('.chips[data-option-index]');
    optWraps.forEach(w => {
      const oi = +w.dataset.optionIndex;
      $$('.opt-chip', w).forEach(ch => {
        const val = ch.dataset.value;
        if (oi === colorIdx) ch.style.background = hexFor(val); else { ch.style.background = 'var(--ink2)'; ch.textContent = val; ch.style.borderRadius = '12px'; ch.style.aspectRatio = 'auto'; ch.style.padding = '10px 14px'; ch.style.color = 'var(--bone)'; ch.style.fontSize = '13px'; }
        ch.onclick = () => {
          const opts = sel.options.slice(); opts[oi] = val;
          const v = product.variants.find(x => x.options.every((o, i) => o === opts[i]));
          if (v) { sel = v; sync(); if (oi === colorIdx) { viewer && viewer.setColor(hexFor(val)); } }
        };
      });
    });
    function sync() {
      optWraps.forEach(w => {
        const oi = +w.dataset.optionIndex;
        $$('.opt-chip', w).forEach(ch => ch.classList.toggle('on', ch.dataset.value === sel.options[oi]));
      });
      priceEl.textContent = money(sel.price);
      atc.dataset.variantId = sel.id;
      atc.disabled = !sel.available;
      atc.textContent = sel.available ? 'Add to Cart' : 'Sold out';
      stickyPrice && (stickyPrice.textContent = money(sel.price));
      stickyMeta && (stickyMeta.textContent = sel.title);
    }
    $$('.qtyrow [data-q]').forEach(b => b.onclick = () => {
      const i = $('#pdQty'); i.value = Math.max(1, (+i.value || 1) + (+b.dataset.q));
    });
    const buy = () => addItems([{ id: sel.id, quantity: Math.max(1, +$('#pdQty').value || 1) }]);
    atc.addEventListener('click', buy);
    $('#stickyAtc') && $('#stickyAtc').addEventListener('click', buy);
    sync();
  }

  /* sticky bar */
  const buyBox = $('#buyBox');
  addEventListener('scroll', () => {
    const r = buyBox.getBoundingClientRect();
    $('#stickybar') && $('#stickybar').classList.toggle('show', r.bottom < 0);
  }, { passive: true });
})();
